import { UiColors } from 'assets/styles/old/global';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  position: relative;
  [type='radio']:checked,
  [type='radio']:not(:checked) {
    position: absolute;
    left: 0;
    opacity: 0;
  }
  [type='radio']:checked + label,
  [type='radio']:not(:checked) + label {
    position: relative;
    padding-left: 28px;
    cursor: pointer;
    display: inline-block;
    color: var(--text-strong);
    font-size: 14px;
  }
  [type='radio']:checked + label:before,
  [type='radio']:not(:checked) + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 16px;
    height: 16px;
    border-radius: 100%;
    background: var(--white);
  }

  [type='radio']:not(:checked) + label:before {
    border: 1px solid var(--dark);
  }

  [type='radio']:checked + label:before {
    border: 1px solid ${UiColors.forestColor};
  }

  [type='radio']:checked + label:after,
  [type='radio']:not(:checked) + label:after {
    content: '';
    width: 10px;
    height: 10px;
    background: ${UiColors.forestColor};
    position: absolute;
    top: 3px;
    left: 3px;
    border-radius: 100%;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }
  [type='radio']:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  [type='radio']:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
`;
export const Label = styled.label``;
export const Input = styled.input`
  &:focus {
    & + label {
      outline: 1px dotted;
      outline: auto -webkit-focus-ring-color;
    }
  }
`;
